import type { IProjectAsset } from '@packages/global';

export function isPlayableMediaUrl(value?: string): value is string {
  if (!value) return false;
  const trimmed = value.trim();
  if (!trimmed) return false;
  return /^(https?:\/\/|blob:|data:audio\/|\/)/i.test(trimmed);
}

export function getAssetMainImageUrl(asset: IProjectAsset, override?: string): string | undefined {
  return override || asset.conceptImageUrl || asset.frontViewUrl;
}

export function getAssetVoiceAudioUrl(asset: IProjectAsset, override?: string): string | undefined {
  if (isPlayableMediaUrl(override)) return override.trim();
  if (isPlayableMediaUrl(asset.voiceReference)) return asset.voiceReference.trim();
  return undefined;
}
